const BREAKPOINTS = {
  xs: 0,
  sm: 1024,
  md: 1280,
  lg: 1512,
  xl: 1920,
  xxl: 2560,
};

export const mediaLgPlus = `@media (min-width: ${BREAKPOINTS.lg}px)`;
export const mediaXlPlus = `@media (min-width: ${BREAKPOINTS.xl}px)`;
export const mediaXxlPlus = `@media (min-width: ${BREAKPOINTS.xxl}px)`;

export const mediaLgMinus = `@media (max-width: ${BREAKPOINTS.lg}px)`;
export const mediaMdMinus = `@media (max-width: ${BREAKPOINTS.md}px)`;

export default BREAKPOINTS;
